import * as React from "react";
import { SVGProps } from "react";
const SvgTaxPlan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M7.8 15.6v-4.2H9v4.2H7.8Zm3.6 0v-4.2h1.2v4.2h-1.2ZM6 18v-1.2h12V18H6Zm9-2.4v-4.2h1.2v4.2H15Zm-9-5.4V9l6-3 6 3v1.2H6ZM8.67 9h6.66L12 7.35 8.67 9Z"
      fill="#fff"
    />
  </svg>
);
export default SvgTaxPlan;
